var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_vm._m(0),_c('div',{staticStyle:{"margin-bottom":"0.2rem"}},[_c('van-button',{attrs:{"block":""},on:{"click":_vm.goBack}},[_vm._v("返回")])],1),_c('div',[_c('van-button',{attrs:{"type":"primary","block":""},on:{"click":_vm.goHome}},[_vm._v("返回首页")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"title"},[_c('p',[_vm._v("404")]),_c('p',[_vm._v("页面不存在")])])
}]

export { render, staticRenderFns }